import { tw } from "@careinfo/tailwind";
import {
  Control,
  Controller,
  FieldError,
  FieldErrors,
  FieldErrorsImpl,
  Merge,
} from "react-hook-form";
import { PhoneInput } from "react-international-phone";
import "./style.css";

interface Props {
  control: Control<any, any>;
  name: string;
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  label: string;
}
const PhoneNumberField = ({ control, name, errors, label }: Props) => {
  return (
    <div className={tw`w-full my-2 text-left mt-4`}>
      <label>
        <span>{label}</span>
        <Controller
          name={name}
          control={control}
          render={({ field }) =>
            field ? (
              <PhoneInput
                className={tw`w-full focus:outline-none bg-[#EEF5F4] mt-1`}
                inputStyle={{
                  backgroundColor: "inherit",
                  border: "none",
                  width: "100%",
                }}
                countrySelectorStyleProps={{
                  buttonStyle: { backgroundColor: "inherit" },
                  dropdownStyleProps: {
                    listItemClassName: tw`border`,
                  },
                }}
                defaultCountry="np"
                value={field.value || ""}
                onChange={field.onChange}
              />
            ) : null
          }
        />
      </label>
      {errors?.message && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors.message}</p>
      )}
    </div>
  );
};

export default PhoneNumberField;
